// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1QRgZ","header":"MergedInvoice_header__3FULG"};